var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubroomIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30z",
    fill: "url(#a-subroom)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57.5c15.188 0 27.5-12.312 27.5-27.5S45.188 2.5 30 2.5 2.5 14.812 2.5 30 14.812 57.5 30 57.5z",
    fill: "url(#b-subroom)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5 29.127-3.125-.625c-.125 0-.25-.25-.25-.375v-.125c0-.125.25-.25.375-.25l3.125.625c.125 0 .25.25.25.375v.125c0 .125-.25.25-.375.25z",
    fill: "url(#c-subroom)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.25 47.5c7.732 0 14-.56 14-1.25S37.982 45 30.25 45s-14 .56-14 1.25 6.268 1.25 14 1.25z",
    fill: "#08212D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.625 11.25h-15.5c-.875 0-1.625.75-1.625 1.625V40.5c0 .875.75 1.625 1.625 1.625H40.25V12.75c0-.75-.75-1.5-1.625-1.5z",
    fill: "#061C28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m33.375 44.5-11.75-2.375V11.25l12.25 2.5c.5.125.875.5.875 1.125V43.5c-.125.625-.75 1.125-1.375 1z",
    fill: "url(#d-subroom)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.25 31.25c-.25 0-.375-.125-.375-.375V28.5c0-.25.125-.375.375-.375s.375.125.375.375v2.375c0 .125-.25.375-.375.375z",
    fill: "#08212D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m32.625 29.375-3-.625c-.25 0-.375-.25-.25-.5 0-.25.25-.375.5-.25l3 .625c.25 0 .375.25.25.5-.125.125-.375.25-.5.25z",
    fill: "url(#e-subroom)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a-subroom",
    x1: 13.468,
    y1: 50.736,
    x2: 46.355,
    y2: 9.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465F6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b-subroom",
    x1: 14.819,
    y1: 49.04,
    x2: 45.017,
    y2: 11.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#465F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#102834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c-subroom",
    x1: 30.062,
    y1: 28.026,
    x2: 29.906,
    y2: 28.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4644C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d-subroom",
    x1: 23.341,
    y1: 39.588,
    x2: 33.894,
    y2: 12.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#EBF87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#EEF98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#F3FBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#F9FDD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e-subroom",
    x1: 31.187,
    y1: 28.274,
    x2: 31.031,
    y2: 29.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#465F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#102834"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubroomIllustration);
export default __webpack_public_path__ + "static/media/subroom-illustration.83ee55a7623edb2432e30675eb122411.svg";
export { ForwardRef as ReactComponent };